import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/Logo.png'
import _imports_1 from '../assets/images/a_b.png'


const _withScopeId = n => (_pushScopeId("data-v-13d5c97e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-center" }
const _hoisted_2 = { class: "home-center-header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "navbar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "navbar_logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_8 = {
  class: "header-section",
  style: {"min-width":"768px","width":"100%","margin-top":"100px"}
}
const _hoisted_9 = { style: {"width":"60%","margin":"0 auto","overflow":"auto","word-wrap":"break-word","margin-bottom":"100px"} }
const _hoisted_10 = { style: {"font-size":"30px"} }
const _hoisted_11 = { style: {"font-size":"15px","color":"#9c9c9c","margin-top":"10px"} }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div data-v-13d5c97e><div class=\"layout-1 other\" data-v-13d5c97e><div class=\"other-bottom\" data-v-13d5c97e><div class=\"box\" data-v-13d5c97e><div class=\"other-bottom-box\" data-v-13d5c97e><p class=\"title\" data-v-13d5c97e>合规举报渠道</p><p class=\"text\" data-v-13d5c97e>合规电话</p><p class=\"text\" data-v-13d5c97e>0553-7526147</p><p class=\"text\" data-v-13d5c97e>合规邮箱</p><p class=\"text\" data-v-13d5c97e>hegui@mychery.com</p></div><div class=\"other-bottom-box\" data-v-13d5c97e><p class=\"title\" data-v-13d5c97e>普思数字化管理平台</p><p class=\"text\" data-v-13d5c97e>产品认证管理系统</p><p class=\"text\" data-v-13d5c97e>标准法规库</p><p class=\"text\" data-v-13d5c97e>数字化道路实验室</p><p class=\"text\" data-v-13d5c97e>业财一体化平台</p><p class=\"text\" data-v-13d5c97e>数据集成系统</p></div><div class=\"other-bottom-box\" data-v-13d5c97e><p class=\"title\" data-v-13d5c97e>联系我们</p><p class=\"text my-box\" data-v-13d5c97e> 公司地址：中国(安徽)自由贸易试验区芜湖片区银湖北路38号留学生楼D501室 </p><p class=\"text my-box\" data-v-13d5c97e> 公司电话：0553-5636736 工作日09:00-18:00 </p><p class=\"text my-box\" data-v-13d5c97e>邮编：241006</p><p class=\"text\" data-v-13d5c97e> </p></div></div></div><div class=\"footer\" data-v-13d5c97e><div data-v-13d5c97e>©2024 普思标准所有</div></div></div></div>", 1)

import { ref } from "vue";
import "../assets/index.scss";
import { useRoute } from "vue-router";
import { contentApi,menusApi } from "../api/content";
import { marked } from "marked";
import router from "@/router";
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentView',
  setup(__props) {

const dynamicData = ref();
const route = useRoute();
const category = route.query.category;
const id = route.query.id;
const render = new marked.Renderer();
const routerData = ref("");

function getContentApi(category: any, id: any) {
  contentApi(category, id).then((res) => {
    const coverUrl =
      res.data.data.attributes.cover.data == null
        ? ""
        : "https://pusi.mychery.com:5443" +
          res.data.data.attributes.cover.data.attributes.url;
    const title = res.data.data.attributes.title;
    const text = marked(res.data.data.attributes.content, { breaks: true });
    const date = moment(res.data.data.attributes.createdAt).format("YYYY-MM-DD")

    dynamicData.value = { img: coverUrl, title: title, text: text, date: date };
  });
}

function getMenu() {
  menusApi().then((res) => {
    routerData.value = res.data.data.attributes.map;
  });
}

getContentApi(category, id);

const activeIndex = ref("1");
const handleSelect = (item: any) => {
  // const obj = routerData.value.find(
  //   (item: any) =>
  //     Number(item.id) ===
  //     (item.length === 1 ? Number(key) : Number(keyPath[0])),
  // );
  if (item) {
    // activeIndex.value = String(obj.id);
    // // 跳锚链接 其他自行处理
    // document.querySelector(obj.path)?.scrollIntoView({
    //   behavior: "smooth",
    //   block: "start",
    //   inline: "nearest",
    // });
    window.open("/"+item.path, "_blank");
  }
};
const handleClick = (item: any) => {
  if(item.type === 'cms'){
    handleListClick(item.cmsinfoid,item.cmsinfoname)
  }else if(item.type === 'system'){
    window.open(item.path, "_blank");
  }else{
    activeIndex.value = String(item.id);
    if (item.path) {
      // 跳锚链接 其他自行处理
      document.querySelector(item.path)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }
};

function handleListClick(id: any,category: any) {
  let routeData = router.resolve({
    path: "/content",
    query: {
      id: id,
      category: category,
    },
  });
  window.open(routeData.href, "_blank");
}

getMenu() 

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_divider = _resolveComponent("el-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_menu, {
            ellipsis: "",
            "default-active": activeIndex.value,
            class: "navbar_list",
            mode: "horizontal",
            "background-color": "rgba(0, 140, 214, 1)",
            "text-color": "rgba(235, 235, 235, 1)",
            "active-text-color": "rgba(235, 235, 235, 1)"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerData.value, (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  (item.children.length === 0)
                    ? (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: 0,
                        index: String(item.id),
                        onClick: ($event: any) => (handleSelect(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["index", "onClick"]))
                    : (item.children.length > 0)
                      ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                          key: 1,
                          index: String(item.id),
                          "popper-class": "navbar_popper navbar_popper_list",
                          onClick: ($event: any) => (handleClick(item)),
                          class: _normalizeClass({ 'is-active': activeIndex.value === String(item.id) })
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("span", {
                              onClick: ($event: any) => (handleSelect(item))
                            }, _toDisplayString(item.title), 9, _hoisted_6),
                            _hoisted_7
                          ]),
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: child.id
                              }, [
                                (child.children.length === 0)
                                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                      key: 0,
                                      index: String(child.pid) + '-' + String(child.id),
                                      onClick: ($event: any) => (handleClick(child))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(child.title), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["index", "onClick"]))
                                  : (child.children.length > 0)
                                    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                        key: 1,
                                        index: String(child.pid) + '-' + String(child.id)
                                      }, {
                                        title: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(child.title), 1)
                                        ]),
                                        default: _withCtx(() => [
                                          (child.children)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(child.children, (sub) => {
                                                return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                  key: sub.id,
                                                  index: String(sub.pid) + '-' + String(sub.id),
                                                  onClick: ($event: any) => (handleClick(sub))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(sub.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["index", "onClick"]))
                                              }), 128))
                                            : (_ctx.sub.children.length > 0)
                                              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                                  key: 1,
                                                  index: String(_ctx.sub.pid) + '-' + String(_ctx.sub.id)
                                                }, {
                                                  title: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.sub.title), 1)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    (_ctx.sub.children)
                                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.sub.children, (subs) => {
                                                          return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                            key: subs.id,
                                                            index:  String(subs.pid) + '-' + String(subs.id) 
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(subs.title), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["index"]))
                                                        }), 128))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 1
                                                }, 8, ["index"]))
                                              : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["index"]))
                                    : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["index", "onClick", "class"]))
                      : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["default-active"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(dynamicData.value && dynamicData.value.title), 1),
        _createElementVNode("div", _hoisted_11, _toDisplayString(dynamicData.value && dynamicData.value.date), 1),
        _createVNode(_component_el_divider),
        _createElementVNode("div", {
          innerHTML: dynamicData.value && dynamicData.value.text,
          style: {"line-height":"1.8"}
        }, null, 8, _hoisted_12)
      ]),
      _hoisted_13
    ])
  ]))
}
}

})